let environment;

export const getEnvironment = (): { [key: string]: string } => {
  return environment;
};

export const setEnvironment = (env) => {
  environment = env;
};
